module.exports = require("@vscode/monaco-editor/esm/vs/base/common/uri");